import React, { Component } from 'react';
import Grid from '@techsoftware/happay-widgets/Grid';
import { Pagination } from '@techsoftware/happay-widgets';
import PropTypes from 'prop-types';
import history from '../../utils/history';
import Table from '../customComponent/customTable';
import TravelConfig from '../../constants/tableListing/tableConfig';
import NoContent from '../customComponent/noContent';
import NoTransactions from '../../assets/images/nocontent/no_transactions.svg';
import Locales from '../../constants/locales';
const TransactionConstants = Locales.JSON.transactions;

export default class BalanceListView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      pageSize: 20,
    };
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    if (this.props.type === 'previousBalance') {
      this.props.getPrviousBalance({
        offset: 0,
        limit: 20,
      });
    } else {
      this.props.getPaymentList({
        offset: 0,
        limit: 20,
        content_type: 'bill_payments',
      });
    }
  }

  componentDidUpdate(prevProps, PrevState) {
    if (prevProps.type !== this.props.type) {
      this.handleTableData(0, 20, 1, 20);
    }
  }

  handleTableData(offset, limit, pageNumber, pageSize) {
    if (this.props.type === 'previousBalance') {
      this.props.getPrviousBalance({
        offset,
        limit,
      });
    } else {
      this.props.getPaymentList({
        offset,
        limit,
        data_type: 'org',
        content_type: 'bill_payments',
      });
    }
    this.setState({
      currentPage: pageNumber,
      pageSize,
    });
  }

  onRowSelect = row => {
    history.push({
      pathname: `/balancedetail/${row.id}`,
    });
  };

  handlePageChange(pageNumber, pageSize = 20) {
    const offset = pageSize * (pageNumber - 1);
    const limit = pageSize * pageNumber;
    this.handleTableData(offset, limit, pageNumber, pageSize);
  }

  onClickAction = (row, action) => {
    history.push({
      pathname: `/balancedetail/${row.id}`,
    });
  };

  render() {
    const { type, showShimmer, billTableCount } = this.props;
    const { currentPage, pageSize } = this.state;
    return (
      <Grid
        xs={24}
        direction="row"
        justify="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={24}>
          <div className="bordered-container no-border-top bill-table-font">
            <div className="padding-t-20 padding-b-20 padding-l-30 padding-r-30">
              <Pagination
                currentPage={currentPage}
                totalDataSize={billTableCount}
                sizePerPage={pageSize}
                onPageChange={this.handlePageChange}
              />
            </div>
            <Table
              shimmerRow={10}
              shimmerColumn={4}
              isDataFetched={!showShimmer}
              headerElements={
                type && TravelConfig[type] ? TravelConfig[type].header : []
              }
              data={this.props[type]}
              customTableOuterStyle={{ height: '600px' }}
              onClickAction={this.onClickAction}
              actions={
                type && TravelConfig[type] ? TravelConfig[type].actions : {}
              }
              colId={
                type && TravelConfig[type] ? TravelConfig[type].col_option : []
              }
              onRowSelect={type !== 'payments' && this.onRowSelect}
              isActionCol={type !== 'payments'}
              selectRows={false}
              selectMultipleRows={false}
              noContent={
                <NoContent
                  message={TransactionConstants.NO_BALANCE}
                  icon={NoTransactions}
                  containerHeight="500px"
                  placement="center"
                />
              }
            />
          </div>
        </Grid>
      </Grid>
    );
  }
}

BalanceListView.propTypes = {
  type: PropTypes.string,
  getPrviousBalance: PropTypes.func,
  getPaymentList: PropTypes.func,
  showShimmer: PropTypes.bool,
  billTableCount: PropTypes.number,
};

BalanceListView.defaultProps = {
  type: 'previousBalance',
  showShimmer: false,
};
